/** A logo file's bytes in standard base64, with padding: what the logo's
 *  door reads. */
export function logoFileBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let at = 0; at < bytes.length; at += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(at, at + 0x8000));
  }
  return btoa(binary);
}

export function parseAllowedOriginsInput(value: string): string[] {
  return value
    .split(/\r?\n/)
    .filter((origin) => origin.trim().length > 0);
}
